import { Component, OnInit } from '@angular/core';
import { FirebaseService } from '../../services/firebase.service';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';

@Component({
	selector: 'app-main-header',
	templateUrl: './main-header.component.html',
	styleUrls: ['./main-header.component.css']
})
export class MainHeaderComponent implements OnInit {
	username:string = 'Guest';

	constructor(
		private firebaseService:FirebaseService,
		private router:Router
	) {
	}

	ngOnInit() {
		this.firebaseService.getAuth().subscribe((user) => {
			if (user)
			{
				this.username = user.email;
			}
			else
			{
				this.username = 'Guest';
			}
		});
	}

	onSignOutClick() {
		this.router.navigate(['']);
		this.firebaseService.userLogout();
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/main-header/main-header.component.ts